import type { AppRoutes } from '@ms/yammer-page-route-telemetry';
import { threadRoutePath } from '@ms/yammer-web-support/dist/urls';

export const pageRoutes: AppRoutes = [
  {
    page: 'Configure',
    path: '/configure',
    exact: true,
    hero: ['teams_meeting_configure'],
    loader: () => import(/* webpackChunkName: "4-page-configure" */ 'pages/PageConfigure'),
  },
  {
    page: 'Thread',
    path: threadRoutePath,
    hero: ['thread', 'thread_deleted_or_private'],
    loader: () => import(/* webpackChunkName: "4-page-thread" */ 'pages/PageThread'),
    dataLoader: () =>
      import(/* webpackChunkName: "4-pagedata-thread" */ '@ms/yammer-data/dist/domains/threadLoad/getThreadLoader'),
  },
  {
    path: '/teams-meeting/:teamsMeetingId',
    loader: () => import(/* webpackChunkName: "4-page-teams-meeting" */ 'pages/PageTeamsMeeting'),
    childRoutes: [
      {
        page: 'TeamsMeetingInReview',
        path: '/in-review',
        exact: true,
        hero: ['feed'],
        loader: () =>
          import(
            /* webpackChunkName: "4-subpage-teams-meeting-in-review" */ '@ms/yammer-web-components/dist/teamsMeeting/PageTeamsMeetingInReviewConversations'
          ),
      },
      {
        page: 'TeamsMeetingPublished',
        path: '/published',
        exact: true,
        hero: ['feed'],
        loader: () =>
          import(
            /* webpackChunkName: "4-subpage-teams-meeting-published" */ '@ms/yammer-web-components/dist/teamsMeeting/PageTeamsMeetingAll'
          ),
      },
      {
        page: 'TeamsMeetingDismissed',
        path: '/dismissed',
        exact: true,
        hero: ['feed'],
        loader: () =>
          import(
            /* webpackChunkName: "4-subpage-teams-meeting-dismissed" */ '@ms/yammer-web-components/dist/teamsMeeting/PageTeamsMeetingDismissedConversations'
          ),
      },
      {
        page: 'TeamsMeetingMy',
        path: '/my',
        exact: true,
        hero: ['feed'],
        loader: () =>
          import(
            /* webpackChunkName: "4-subpage-teams-meeting-my" */ '@ms/yammer-web-components/dist/teamsMeeting/PageTeamsMeetingMyConversations'
          ),
      },
    ],
    fallbackRedirectRoute: {
      page: 'TeamsMeeting',
      hero: ['feed', 'content_inaccessible'],
      loader: () =>
        import(
          /* webpackChunkName: "4-subpage-teams-meeting-fallback" */ '@ms/yammer-web-components/dist/teamsMeeting/SubpageTeamsMeetingFallbackRedirect'
        ),
    },
  },
];
